module.exports = __webpack_public_path__ + "static/banner-bubble-23879370e5fb04fe9a5621026703073f.png";